import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActionSheetController } from '@ionic/angular';
import { AuthService } from '../services/auth.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-tabs',
  templateUrl: 'tabs.page.html',
  styleUrls: ['tabs.page.scss'],
})
export class TabsPage implements OnInit {
  token = '';

  isFrom_Ig_IOS: boolean = false;

  translateKeys = {
    TABS_MAPA : "TABS.MAP",
    TABS_EXPLORE : "TABS.EXPLORE",
    TABS_EXPERIENCES: "TABS.EXPERIENCES",
    TABS_PROFILE: "TABS.PROFILE",
    TABS_HOME: "TABS.HOME",
    TABS_EXPLORA : "TABS.EXPLORA",

    MODALS_SPECTATOR_HEADER: "MODALS.SPECTATOR.HEADER",
    MODALS_SPECTATOR_BUTTONS_LOGIN: "MODALS.SPECTATOR.BUTTONS.LOGIN",
    MODALS_SPECTATOR_BUTTONS_VIEW_AS_SPECTATOR: "MODALS.SPECTATOR.BUTTONS.VIEW_AS_SPECTATOR"
  }

  constructor(
    private actionSheetCtrl: ActionSheetController,
    private router: Router,
    public auth: AuthService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    // isFrom_Ig_IOS
    const browser = navigator.userAgent || navigator.vendor || window['opera'];
    var isInstagram = browser.indexOf('Instagram') > -1 ? true : false;
    const OS = this.getMobileOperatingSystem();

    if (isInstagram && OS === 'iOS') {
      this.isFrom_Ig_IOS = false;
    }
  }



  getMobileOperatingSystem() {
    let userAgent = navigator.userAgent || navigator.vendor || window['opera'];

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return 'Windows Phone';
    }

    if (/android/i.test(userAgent)) {
      return 'Android';
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window['MSStream']) {
      return 'iOS';
    }

    return 'unknown';
  }

  async showAccessOptions() {
    if (this.auth.isLogged()) {
      this.router.navigate(['/app/profile']);
    }

    let result = this.translate.instant([
      this.translateKeys.MODALS_SPECTATOR_HEADER,
      this.translateKeys.MODALS_SPECTATOR_BUTTONS_LOGIN,
      this.translateKeys.MODALS_SPECTATOR_BUTTONS_VIEW_AS_SPECTATOR ]);

    const actionSheet = await this.actionSheetCtrl.create({
      header: result[this.translateKeys.MODALS_SPECTATOR_HEADER],
      buttons: [
        {
          text: result[this.translateKeys.MODALS_SPECTATOR_BUTTONS_LOGIN],
          role: 'GoToLogin',
        },
    /*     {
          text: result[this.translateKeys.MODALS_SPECTATOR_BUTTONS_VIEW_AS_SPECTATOR],
          role: 'GoToProfile',
        }, */
      ],
    });

    actionSheet.present();

    const { role } = await actionSheet.onWillDismiss();

    if (role === 'GoToLogin') {
      this.router.navigate(['/login']);
    } else if (role === 'GoToProfile') {
      this.auth.loginAsSpectator();
      this.router.navigate(['/app/profile']);
    }
  }
}
